import { MailProfileAction } from './MailProfileReducer'
import { MailProfileStateKey } from './MailProfileState'
import { MailProfileType } from './MailProfileType'

export function saveUserProfile(value: Object) {
  return {
    type: MailProfileType.SAVE_PROFILE,
    payload: { value }
  }
}

export function updateMailProfileAction(key: MailProfileStateKey, value: string | number | boolean | undefined): MailProfileAction {
  return {
    type: MailProfileType.UPDATE_PROFILE,
    payload: { key, value }
  }
}

export function cleanUserProfile() {
  return {
    type: MailProfileType.CLEAN_PROFILE
  }
}
